import React, { useState } from 'react';
import './Indexs.css';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { PaymentDetailsTable, ProductTable, ShippingDetials } from '..';

import { useUser } from '../../Context/User';

const Reviews = ({ next, prev, addMore }) => {
    const [billInvoice, setInvoice] = useState('');
    const { cart } = useUser();
    return (
        <div className="review_product">
            <div className="order_details">
                <div style={{ marginBottom: '1.4rem' }} className="home_head">
                    <h2 className="home_heading">Order Details</h2>
                    <h2 className="home_heading">Order ID: XXXXXXXX</h2>
                </div>
                <ProductTable addMore={addMore} products={[...cart]} showProps={true} />
            </div>
            <ShippingDetials />
            <div className="payment_details">
                <div style={{ marginBottom: '1.4rem' }} className="home_head">
                    <h2 className="home_heading">Payment Details</h2>
                </div>
                <PaymentDetailsTable subtotal={183.75} shipping={55.0} credit={0.0} />
            </div>
            <div className="payment_details">
                <div style={{ marginBottom: '1.4rem' }} className="home_head">
                    <h2 className="home_heading">Payment Type</h2>
                </div>
                <div className="payment_details_payment_type">
                    <RadioGroup aria-label="payemntType" name="payemntType">
                        <FormControlLabel value="male" control={<Radio />} label="Prepaid" />
                        <FormControlLabel value="female" control={<Radio />} label="Cash On delivery" />
                    </RadioGroup>
                </div>
            </div>
            <div className="payment_details">
                <div style={{ marginBottom: '1.4rem' }} className="home_head">
                    <h2 className="home_heading">Remarks (Optional)</h2>
                </div>
                <div className="payment_details_payment_type">
                    <textarea className="payment_details_payment_type_remarks" placeholder="Remarks 200 Words Max" />
                </div>
            </div>
            <div className="confirm_product_footer">
                <div className="confirm_product_footer_left">
                    <input
                        style={{ marginRight: '2rem' }}
                        placeholder="Enter invoice Number"
                        value={billInvoice}
                        onChange={(e) => {
                            setInvoice(e.target.value);
                        }}
                        className="confirm_products_summary_invoice"
                    />

                    <input
                        name="Invoice"
                        style={{ visibility: 'hidden', display: 'none' }}
                        accept="application/msword,.docx, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                        text/plain, application/pdf"
                        id="uploadInvoice"
                        type="file"
                    />
                    <button className="btn-gray">
                        <label htmlFor="uploadInvoice">
                            <p>Upload Invoice</p>
                        </label>
                    </button>
                </div>
                <div className="confirm_product_footer_right">
                    <button onClick={prev} style={{ marginRight: '2rem' }} className="btn-gray">
                        <KeyboardBackspaceIcon className="btn-icon " />
                        <p>Back</p>
                    </button>
                    <button onClick={next} className="btn-orange ">
                        <p>Recharge for RS. 233.75</p>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Reviews;
